import { z } from "zod";

export const FormSchema = z.object({
  name: z
    .string({ required_error: "O campo deve conter pelo menos 1 caractere." })
    .min(2, { message: "Deve ter pelo menos 2 caracteres." }),
});
